if ($('.variant-list, .surcharge-list').length > 0) {
    $('body').addClass('hasVariants');

    function parseVariantOptionText(rawText) {
        var text = $.trim(String(rawText || '').replace(/\u00a0/g, ' '));
        text = text.replace(/\s+/g, ' ');

        // Odstranění ceny na konci:
        // CZ: (1 990 Kč)
        // EN/EUR: (€79), (79 €), případně jiné měnové formáty
        var withoutPrice = text.replace(
            /\s*\([^)]*(?:Kč|CZK|€|EUR)[^)]*\)\s*$/i,
            ''
        ).trim();

        // CZ: Velikost: 38
        // EN: Size: 38
        var sizeMatch = withoutPrice.match(
            /(?:^|\b)(?:Velikost|Size)\s*:\s*([^\-\(]+)/i
        );

        var size = sizeMatch
            ? $.trim(sizeMatch[1])
            : $.trim(
                withoutPrice
                    .replace(/^(?:Velikost|Size)\s*:\s*/i, '')
            );

        var availability = '';

        // CZ + EN
        if (/nedostupn|unavailable/i.test(withoutPrice)) {
            availability = translation('unavailable');
        }
        else if (/skladem|in stock/i.test(withoutPrice)) {
            availability = translation('inStock');
        }
        else if (/dotaz|on request/i.test(withoutPrice)) {
            availability = translation('onRequest');
        }
        else {
            // pomlčka musí být oddělená mezerou, jinak by se rozsah
            // velikostí "36-39" chybně vyhodnotil jako dostupnost
            var stockMatch = withoutPrice.match(/\s-\s*([^\(]+)$/);

            if (stockMatch) {
                availability = $.trim(stockMatch[1]);
            }
        }

        return {
            size: size,
            availability: availability
        };
    }


    function getAvailabilityClass(availabilityText) {
        var normalized = String(availabilityText || '').toLowerCase();

        // CZ + EN
        if (
            normalized.indexOf('skladem') !== -1 ||
            normalized.indexOf('in stock') !== -1
        ) {
            return 'skladem';
        }

        if (
            normalized.indexOf('nedostup') !== -1 ||
            normalized.indexOf('unavailable') !== -1
        ) {
            return 'nedostupne';
        }

        if (
            normalized.indexOf('dotaz') !== -1 ||
            normalized.indexOf('on request') !== -1
        ) {
            return 'dotaz';
        }

        return 'dostupnost';
    }


    function updateCustomCartPrice(priceText) {
        if (!priceText) {
            return;
        }

        var $customPrice = $('.customCart .p-final-price-wrapper .price-final');

        if ($customPrice.length) {
            $customPrice.html(priceText);
            return;
        }

        var $customWrapper = $('.customCart .p-final-price-wrapper');

        if ($customWrapper.length) {
            $customWrapper.html(
                '<strong class="price-final">' + priceText + '</strong>'
            );
        }
    }


    var $howToSelectRow = $('.extended-description .row-header-label.has-tooltip').filter(function () {
        return $(this).text().indexOf('jakVybratPopUp') !== -1;
    }).closest('tr');

    $howToSelectRow.addClass('hidden');

    var howToSelectText = $.trim(
        $howToSelectRow.find('td').first().text()
    );

    var howToSelectHref =
        $howToSelectRow
            .find('.show-tooltip.question-tooltip')
            .attr('data-original-title') ||
        $howToSelectRow
            .find('.show-tooltip.question-tooltip')
            .attr('title') ||
        '';

    var hasHowToSelect =
        howToSelectText !== '' ||
        howToSelectHref !== '';


    $('.variant-list select, .surcharge-list select').each(function () {

        if (
            $(this)
                .closest('.surcharge-list')
                .find('th .show-tooltip')
                .length
        ) {
            var listTootip = $(this)
                .closest('.surcharge-list')
                .find('th .show-tooltip')
                .attr('title');
        }
        else {
            listTootip = '';
        }


        var selectIndex = $(
            '.variant-list select, .surcharge-list select'
        ).index(this);

        var optionLength = $(this).find('option').length;

        var data_parameter_id = $(this).data('parameter-id');

        if (
            typeof data_parameter_id === 'undefined' ||
            data_parameter_id === null ||
            data_parameter_id === ''
        ) {
            data_parameter_id = 'fallback-' + selectIndex;
        }


        var howToSelectHtml = '';

        if (hasHowToSelect) {

            // CZ / EN překlad
            howToSelectHtml = translation('howToSelectSkates');

            if (howToSelectText !== '') {
                howToSelectHtml +=
                    '<span class="inner"> ' +
                    howToSelectText +
                    '?</span>';
            }
        }


        var howToSelectDataHref = '';

        if (
            hasHowToSelect &&
            howToSelectHref !== ''
        ) {
            howToSelectDataHref =
                ' data-popup-href="' +
                howToSelectHref +
                '"';
        }


        var html_var =
            '<div class="custom-variant" data-groupId="' +
            data_parameter_id +
            '">' +
            '<div class="h3">' +
            translation('choosesizes') +
            '</div>';


        if (hasHowToSelect) {
            html_var +=
                '<span class="howToSelect"' +
                howToSelectDataHref +
                '>' +
                howToSelectHtml +
                '</span>';
        }


        html_var +=
            '<div class="custom-variant-wrap" ' +
            'data-param-id="' +
            data_parameter_id +
            '" ' +
            'data-select-index="' +
            selectIndex +
            '">';


        $(this).find('option').each(function () {

            var data_value = $(this).attr('value');


            if ($.isNumeric($(this).val())) {

                var parsedOption =
                    parseVariantOptionText(
                        $(this).text()
                    );


                var variantClassKey =
                    data_parameter_id +
                    '-' +
                    data_value;


                var variantPrice = '';


                var $variantPriceHolder =
                    $('.price-final-holder.parameter-dependent')
                        .filter(function () {
                            return $(this)
                                .hasClass(variantClassKey);
                        })
                        .first();


                if ($variantPriceHolder.length) {

                    variantPrice = $.trim(
                        $variantPriceHolder.text()
                    ).replace(/\s+/g, ' ');

                }
                else {

                    // CZK / Kč / EUR / €
                    var textPriceMatch =
                        $(this)
                            .text()
                            .match(
                                /\(([^)]*(?:Kč|CZK|€|EUR)[^)]*)\)/i
                            );


                    if (
                        textPriceMatch &&
                        textPriceMatch[1]
                    ) {
                        variantPrice = $.trim(
                            textPriceMatch[1]
                        ).replace(/\s+/g, ' ');
                    }
                }


                html_var +=
                    '<div class="variant haveVariant" ' +
                    'data-value="' +
                    data_value +
                    '" ' +
                    'data-select-index="' +
                    selectIndex +
                    '" ' +
                    'data-parameter-id="' +
                    data_parameter_id +
                    '" ' +
                    'data-param-val="' +
                    data_parameter_id +
                    '-' +
                    data_value +
                    '" ' +
                    'data-price="' +
                    variantPrice +
                    '">';


                html_var +=
                    '<div class="text">';


                html_var +=
                    '<label>' +
                    parsedOption.size +
                    '</label>';


                if (
                    parsedOption.availability !== ''
                ) {
                    html_var +=
                        '<div class="availability ' +
                        getAvailabilityClass(
                            parsedOption.availability
                        ) +
                        '">' +
                        parsedOption.availability +
                        '</div>';
                }


                if (listTootip !== '') {

                    // Původně pouze "0 Kč".
                    // Zachováno + doplněna podpora dalších měn.
                    var optionText = $(this).text();

                    var isZeroPrice =
                        optionText.indexOf('0 Kč') !== -1 ||
                        optionText.indexOf('0 CZK') !== -1 ||
                        optionText.indexOf('0 €') !== -1 ||
                        optionText.indexOf('€0') !== -1 ||
                        optionText.indexOf('0 EUR') !== -1;


                    if (!isZeroPrice) {
                        html_var +=
                            '<span class="show-tooltip question-tooltip" ' +
                            'title="' +
                            listTootip +
                            '">?</span>';
                    }
                }


                html_var += '</div>';

                html_var += '</div>';
            }

        });


        html_var += '</div>';

        html_var += '</div>';


        $(this).after(html_var);


        $(this)
            .closest(
                '.variant-list select, .surcharge-list select'
            )
            .hide();


        $(this)
            .closest(
                '.variant-list span, .surcharge-list span'
            )
            .hide();

    });


    var necessaryVariantData =
        shoptet.variantsSplit.necessaryVariantData;


    for (var parentKey in necessaryVariantData) {

        if (
            necessaryVariantData.hasOwnProperty(
                parentKey
            )
        ) {

            var variant =
                necessaryVariantData[parentKey];


            // U produktů s více parametry (např. barva + velikost) je klíč
            // složený "4-126-5-1128" – tlačítko velikosti má jen "5-1128".
            var keyParts = parentKey.split('-');
            var buttonKey = keyParts.length > 2
                ? keyParts.slice(-2).join('-')
                : parentKey;


            $('.custom-variant-wrap .variant[data-param-val="' + buttonKey + '"]')
                .attr(
                    'data-price-id',
                    variant.id
                )
                .attr(
                    'data-avail',
                    variant.availabilityName
                        .normalize("NFD")
                        .replace(
                            /[\u0300-\u036f]/g,
                            ""
                        )
                        .replace(/ /g, '-')
                )
                .attr(
                    'data-sale',
                    variantHasSale(parentKey)
                )
                .each(function () {

                    var $text =
                        $(this).find('.text');

                    var $availability =
                        $text.find('.availability');

                    if (!$availability.length) {
                        $availability =
                            $('<div class="availability"></div>')
                                .appendTo($text);
                    }

                    $availability
                        .attr(
                            'class',
                            'availability ' +
                            getAvailabilityClass(
                                variant.availabilityName
                            )
                        )
                        .text(variant.availabilityName);


                    // Barva přímo z dat Shoptetu (štítek .availability-label
                    // nemusí mít třídu parameter-dependent, např. u jedné varianty)
                    if (variant.availabilityColor) {
                        $availability.css(
                            'color',
                            variant.availabilityColor
                        );
                    }

                });

        }
    }

}




function variantHasSale(variantKey) {

    if (
        !window.shoptet ||
        !shoptet.variantsSplit ||
        !shoptet.variantsSplit.necessaryVariantData
    ) {
        return false;
    }


    var variantData =
        shoptet.variantsSplit
            .necessaryVariantData[variantKey];


    if (!variantData) {
        return false;
    }


    var standardPrice = parseInt(
        String(
            variantData.standardPrice || ''
        ).replace(/\D/g, ''),
        10
    );


    var finalPrice = parseInt(
        String(
            variantData.price || ''
        ).replace(/\D/g, ''),
        10
    );


    return (
        !isNaN(standardPrice) &&
        !isNaN(finalPrice) &&
        standardPrice > 0 &&
        standardPrice > finalPrice
    );
}




function updateCustomCartSaleState() {

    var hasSale =
        $('.custom-variant-wrap .variant.active')
            .filter(function () {
                return (
                    $(this).attr('data-sale') ===
                    'true'
                );
            })
            .length > 0;


    $('.customCart')
        .toggleClass(
            'sale',
            hasSale
        );
}




$(document).on(
    'click',
    '.custom-variant-wrap .variant',
    function () {

        const variantData =
            $(this).data('value');


        const variantParameterId =
            $(this).data('parameter-id');


        var variantSelectIndex =
            $(this).data('select-index');


        var $targetSelect =
            $(
                "select[data-parameter-id='" +
                variantParameterId +
                "']"
            );


        if (
            !$targetSelect.length &&
            typeof variantSelectIndex !==
                'undefined'
        ) {

            $targetSelect =
                $(
                    '.variant-list select, .surcharge-list select'
                ).eq(
                    variantSelectIndex
                );
        }


        $targetSelect
            .find("option")
            .filter(function () {
                return (
                    $(this).attr('value') ==
                    variantData
                );
            })
            .prop(
                "selected",
                true
            )
            .change();


        $(this)
            .closest(
                '.custom-variant-wrap[data-param-id="' +
                variantParameterId +
                '"]'
            )
            .find(
                ".variant:not([data-value='" +
                variantData +
                "'])"
            )
            .removeClass(
                "active"
            );


        $(this)
            .addClass(
                "active"
            );


        var selectedPrice = $.trim(
            $(this).attr('data-price') || ''
        ).replace(/\s+/g, ' ');


        if (
            selectedPrice !== ''
        ) {
            updateCustomCartPrice(
                selectedPrice
            );
        }



        var selector =
            '.variant-list .hidden-split-parameter, ' +
            '.variant-list .split-parameter';


        var $splitParameters =
            $(selector);


        $splitParameters
            .trigger('change');


        if (
            $targetSelect.length &&
            $targetSelect[0]
        ) {

            $targetSelect[0]
                .dispatchEvent(
                    new Event('change')
                );
        }


        $('.custom-variant-wrap .variant')
            .each(function () {

                const variantData =
                    $(this).data('value');


                const variantParameterId =
                    $(this).data(
                        'parameter-id'
                    );


                const variantSelectIndex =
                    $(this).data(
                        'select-index'
                    );


                var $checkSelect =
                    $(
                        "select[data-parameter-id='" +
                        variantParameterId +
                        "']"
                    );


                if (
                    !$checkSelect.length &&
                    typeof variantSelectIndex !==
                        'undefined'
                ) {

                    $checkSelect =
                        $(
                            '.variant-list select, .surcharge-list select'
                        ).eq(
                            variantSelectIndex
                        );
                }


                const unavailable =
                    $checkSelect
                        .find(
                            "option[value='" +
                            variantData +
                            "']"
                        )
                        .hasClass(
                            "unavailable-option"
                        );


                if (
                    unavailable === true
                ) {

                    $(this)
                        .addClass(
                            "unavailable"
                        )
                        .removeClass(
                            "active"
                        );

                }
                else {

                    $(this)
                        .removeClass(
                            "unavailable"
                        );

                }

            });


        updateCustomCartSaleState();

    }
);




$(document).on(
    'click',
    '#jsUnavailableCombinationMessage a',
    function () {

        $('.custom-variant-wrap .variant')
            .removeClass(
                'unavailable'
            );

    }
);




$(document).on(
    'click',
    '.custom-variant .howToSelect',
    function (e) {

        var popupHref =
            $(this).attr(
                'data-popup-href'
            );


        if (!popupHref) {
            return;
        }


        e.preventDefault();


        $.get(
            popupHref,
            function (html) {

                const content =
                    $(html)
                        .find(
                            '.pageArticleDetail'
                        )
                        .html();


                $.colorbox({
                    html:
                        `<div class="howToSelectPopUp">${content}</div>`,
                    width: '960px',
                    maxWidth: '90%',
                    height: '90%'
                });

            }
        );

    }
);




$(document).ready(function () {

    $(".custom-variant-wrap")
        .each(function () {

            var $variants =
                $(this)
                    .find(
                        "div.variant"
                    );


            if (
                $variants.length === 1
            ) {
                $variants
                    .addClass(
                        "active"
                    );
            }

        });


    var urlParams =
        new URLSearchParams(
            window.location.search
        );


    var parameterValueId =
        urlParams.get(
            "parameterValueId"
        );


    var $divToHighlight =
        $(
            "div.variant[data-value='" +
            parameterValueId +
            "']"
        );


    if (
        $divToHighlight.length > 0
    ) {
        $divToHighlight
            .addClass(
                "active"
            );
    }


    var selectedPrice = $.trim(
        $('.custom-variant-wrap .variant.active')
            .first()
            .attr(
                'data-price'
            ) || ''
    ).replace(
        /\s+/g,
        ' '
    );


    if (
        selectedPrice !== ''
    ) {
        updateCustomCartPrice(
            selectedPrice
        );
    }


    updateCustomCartSaleState();

});